module.exports = __webpack_public_path__ + "img/button_kids.f5696fdc.png";